import { render, staticRenderFns } from "./VersionWeb.vue?vue&type=template&id=24bcbe23&scoped=true"
import script from "./VersionWeb.vue?vue&type=script&lang=js"
export * from "./VersionWeb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bcbe23",
  null
  
)

export default component.exports